// Footer links removed from homepage as requested
export default function FooterLinks() {
  return null;
}